import GOFModel from '../models/GOFModel'
import GOFResponseModel from '../models/GOFResponseModel'
import RecordModel from '../models/RecordModel'

export const createGOFResponseModel = (
   gofResponseId: string,
   gof: GOFModel,
   record: RecordModel
): GOFResponseModel => new GOFResponseModel(gofResponseId, gof, record)
